module.exports = __webpack_public_path__ + "media/images/up_brown-3cdf43bbc392ad70f3f2589b17832285.png";